import React, { useContext, useState } from "react";
import { useFormContext } from "react-hook-form";
import styled, { css } from "styled-components";
import { Toggle } from "../../Toggle";
import { FormFieldGroupContext } from "../FormFieldGroup";
import { GenericFormContext } from "../GenericFormContext";
import { useCheckedFromDefaultValues } from "../FormCheckbox";
export const FormToggle = (props) => {
    const { name, label, disabled: disabledFromProps = false, defaultChecked, readOnly = false } = props;
    const { disabled: disabledFromFormFieldGroup } = useContext(FormFieldGroupContext);
    const { editIsAllowed } = useContext(GenericFormContext);
    const { register, setValue } = useFormContext();
    const checkedFromDefaultValues = useCheckedFromDefaultValues(name, defaultChecked);
    const [checked, setChecked] = useState(checkedFromDefaultValues);
    // We don't set disabled to `false` in order to avoid react-hook-form errors.
    const disabledState = disabledFromProps || disabledFromFormFieldGroup ? true : undefined;
    const readOnlyState = readOnly === true || editIsAllowed === false;
    const handleChange = () => {
        setChecked(!checked);
        setValue(name, !checked);
    };
    const { onBlur, ref } = register(name, {
        disabled: disabledState,
        value: checked,
    });
    return (React.createElement("div", null,
        React.createElement(Label, { readOnlyState: readOnlyState, onClick: (event) => {
                if (readOnlyState) {
                    event.preventDefault();
                }
            } },
            React.createElement(Toggle, { checked: checked, name: name, disabled: disabledState, onBlur: onBlur, onChange: handleChange, readOnly: readOnlyState, ref: ref }),
            React.createElement(LabelText, null, label))));
};
const Label = styled.label `
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => `${theme.space[2]}px`};

  ${({ readOnlyState }) => readOnlyState &&
    css `
      cursor: not-allowed;

      & > * {
        pointer-events: none !important;
      }
    `}
`;
const LabelText = styled.span `
  flex: 1;
`;
